export interface RequestAirlineInfoInterface {
  slug: string;
}

export interface ContentSectionInterface {
  title: string;
  data: string;
}

export interface AirlineInfo {
  name: string;
  nameEn: string;
  slug: string;
  airlineCode: string;
  banner: string;
  logo: string;
  phone: string;
  website: string;
  email: string;
  address: string;
  history: ContentSectionInterface;
  description: ContentSectionInterface;
  facility: ContentSectionInterface;
  route: ContentSectionInterface;
  baggage: ContentSectionInterface;
  whybook: ContentSectionInterface;
  airlineAlliance?: string;
  review: Review;
}

export interface Review {
  latitude: string;
  rating: number;
  location_id: string;
  reviews: Review2[];
  write_review: string;
  longitude: string;
  hotel_booking: HotelBooking;
  review_rating_count: ReviewRatingCount;
  review_count: number;
}

export interface Review2 {
  id: string;
  lang: string;
  location_id: string;
  published_date: string;
  rating: number;
  helpful_votes: string;
  rating_image_url: string;
  url: string;
  travel_date: string;
  text: string;
  user: User;
  title: string;
  is_machine_translated: boolean;
  trip_type: string;
  // flying_from: string
  // flying_to: string
  // flight_number?: string
  // recommend_airline: string

  legroom?: string;
  seat_comfort?: string;
  entertainment?: string;
  customer_service?: string;
  value_money?: string;
  cleanliness?: string;
  checkin_boarding?: string;
  food_beverage?: string;
  pay_legroom_recc?: boolean;
  pay_addon_recc?: boolean;
  children_recc?: boolean;
  subratings: Subrating[];
}

export interface User {
  username: string;
  user_location: UserLocation;
}

export interface UserLocation {
  name?: string;
  id?: string;
}

export interface Subrating {
  rating_image_url: string;
  name: string;
  value: string;
  localized_name?: string;
}

export interface HotelBooking {
  bookable: boolean;
  booking_url: any;
}

export interface ReviewRatingCount {
  "1": string;
  "2": string;
  "3": string;
  "4": string;
  "5": string;
}

export interface AirlinePromotion {
  id: number;
  title: string;
  description: string;
  startPrice: number;
  currency: string;
  product: string[];
  fullImage: string;
  thumbImage: string;
  mobileImage: string;
  homeImage: string;
  slug: string;
  url: string;
  subtitle: string;
}

export interface ResponseAirlinesBySlugInterface {
  status: boolean;
  airlineInfo: AirlineInfo;
  promotions: AirlinePromotion[];
}

export class ResponseAirlinesBySlugClass {
  status: boolean;

  airlineInfo: AirlineInfo;

  promotions: AirlinePromotion[];

  constructor(data: any) {
    this.status = data.status || false;
    this.airlineInfo = data.airlineInfo || {};
    this.promotions = data.promotions
      ? data.promotions.map((item: AirlinePromotion) => {
          return {
            id: "",
            title: "",
            description: "",
            startPrice: item.startPrice || 0,
            currency: item.currency || "",
            product: item.product,
            fullImage: item.fullImage || "",
            thumbImage: item.thumbImage || "",
            mobileImage: item.mobileImage || "",
            homeImage: item.homeImage || "",
            slug: item.slug || "",
            url: item.url || "",
            subtitle: item.subtitle || "",
          };
        })
      : null;
  }
}
